import React, { useState, useEffect } from "react";
import notify from './notifier';
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/user";
import { useCompany } from '../CompanyContext';

export const ProtectedRoute = ({ element: Component, requiredPrivileges = [], ...rest }) => {
  const [authStatus, setAuthStatus] = useState(null); // `null` means loading
  const { overallCompany } = useCompany();

  useEffect(() => {
    const checkAuth = async () => {
      const val = await isAuthenticated();
      setAuthStatus(val);
    };
    checkAuth();
  }, []);

  const hasRequiredPrivileges = (privileges) => {
    // If no privileges are required, allow access
    if (!privileges || privileges.length === 0) {
      return true;
    }

    try {
      // Get stored privileges from localStorage
      const userPrivileges = JSON.parse(localStorage.getItem('location_service_privileges') || '[]');
      
      // Check if user has any of the required privileges
      return Array.isArray(userPrivileges) && 
             privileges.some(privilege => userPrivileges.includes(privilege));
    } catch (error) {
      console.error('Error checking privileges:', error);
      return false;
    }
  };

  if (authStatus === null) {
    // Show a loading indicator while checking authentication
    return <div>Loading...</div>;
  }
  const location = useLocation();

  if (authStatus) {
    if (hasRequiredPrivileges(requiredPrivileges)) {
      return <Component currentCompany={overallCompany} {...rest} />;
    }
    else {
      // User lacks required privileges, notify and redirect
      notify({
        type: "error",
        message: "You don't have permission to access this page.",
        autoClose: 7000,
        limit: 1
      });
      
      // Redirect to home or an unauthorized page
      return (
        <Navigate
          to="/unauthorized" state= {{ 
              from: location,
              requiredPrivileges: requiredPrivileges 
            }} replace
        />
      );
    }
  } else {
    notify({
      type: 'warn',
      message: 'Session timed out, please login again.',
      autoClose: 7000,
      limit: 1
    });

    // Redirect to the login page with a state for the redirection source
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
};